import React, { useState } from 'react';
import { MapContainer, CircleMarker, Popup, useMap } from 'react-leaflet';
import { Link } from 'react-router-dom';
import { BasemapLayers, BasemapToggle } from './MapBasemaps';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fit the map view to all job markers
function FitBounds({ points }) {
  const map = useMap();
  React.useEffect(() => {
    if (!points || points.length === 0) return;
    if (points.length === 1) {
      map.setView([points[0].latitude, points[0].longitude], 11);
      return;
    }
    const bounds = L.latLngBounds(points.map(p => [p.latitude, p.longitude]));
    map.fitBounds(bounds, { padding: [30, 30], maxZoom: 13 });
  }, [points, map]);
  return null;
}

export default function DashboardMap({ jobs = [], height = 320 }) {
  const [basemap, setBasemap] = useState('satellite');
  const points = jobs.filter(j => j.latitude != null && j.longitude != null);
  const center = points.length
    ? [points[0].latitude, points[0].longitude]
    : [34.0, -84.0]; // fallback: north Georgia

  return (
    <div style={{ height, borderRadius: '0.5rem', overflow: 'hidden', position: 'relative' }}>
      <MapContainer
        center={center}
        zoom={9}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
      >
        <BasemapLayers basemap={basemap} />
        <FitBounds points={points} />
        {points.map(job => (
          <CircleMarker
            key={job.id}
            center={[job.latitude, job.longitude]}
            radius={7}
            pathOptions={{
              color: '#fff',
              weight: 2,
              fillColor: job.color || '#2563eb',
              fillOpacity: 0.95,
            }}
          >
            <Popup>
              <div style={{ minWidth: 140 }}>
                <Link to={`/jobs/${job.id}`} style={{ fontWeight: 700, color: '#2563eb', textDecoration: 'none' }}>
                  {job.job_number}
                </Link>
                <div style={{ fontSize: 12, color: '#444', marginTop: 2 }}>{job.client_name || 'No client'}</div>
                {job.property_address && (
                  <div style={{ fontSize: 11, color: '#777', marginTop: 2 }}>{job.property_address}</div>
                )}
                <div style={{ fontSize: 11, marginTop: 4 }}>
                  <span style={{
                    background: job.color || '#6b7280', color: '#fff',
                    padding: '1px 6px', borderRadius: 8,
                  }}>{job.status}</span>
                </div>
              </div>
            </Popup>
          </CircleMarker>
        ))}
      </MapContainer>
      <BasemapToggle basemap={basemap} setBasemap={setBasemap} />
    </div>
  );
}
